import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgForage } from 'ngforage';
import { Lightbox } from 'ngx-lightbox';
import AssetHelper from 'src/app/helpers/asset-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Asset from 'src/app/model/asset';
import { ModalService } from 'src/app/services/modal.service';
import { FileHelper } from '../../../../../../helpers/file-helper';

@Component({
  selector: 'immo-ip-placer-immo-task-execution-assets',
  templateUrl: './immo-ip-placer-immo-task-execution-assets.component.html',
  styleUrls: ['./immo-ip-placer-immo-task-execution-assets.component.scss'],
})
export class ImmoIPPlacerImmoTaskExecutionAssetsComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input()
  assets: Asset[];

  @Input()
  disabled: boolean;

  @Input()
  storingOfflineChange: boolean;

  @Output()
  assetsAdded = new EventEmitter<Asset[]>();

  @Output()
  assetDeleted = new EventEmitter<Asset>();

  init: boolean = false;

  private blobUrls: string[] = [];

  isImage = FileHelper.isImage;
  constructor(
    private ngForage: NgForage,
    private sanitizer: DomSanitizer,
    private modalService: ModalService,
    private _lightbox: Lightbox
  ) {}

  ngOnInit(): void {
    this.initializeLocalSafeUrls().finally(() => (this.init = true));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes != null &&
      changes.assets != null &&
      !changes.assets.isFirstChange()
    ) {
      this.revokeBlobUrls();
      this.initializeLocalSafeUrls();
    }
  }

  private async initializeLocalSafeUrls(): Promise<void> {
    if (!CollectionHelper.isPopulated(this.assets)) {
      return;
    }

    const loadOfflineAssetsPromises = [];
    this.assets.forEach((a) => {
      if (a.localFileUuid != null) {
        loadOfflineAssetsPromises.push(this.loadOfflineAsset(a));
      }
    });

    if (loadOfflineAssetsPromises.length > 0) {
      await Promise.all(loadOfflineAssetsPromises);
    }
  }

  private async loadOfflineAsset(asset: Asset): Promise<void> {
    const file = await this.ngForage.getItem<File>(
      AssetHelper.getStorageKeyFor(asset.localFileUuid)
    );
    if (file != null) {
      const objectURL = URL.createObjectURL(file);
      this.blobUrls.push(objectURL);
      asset.localSafeUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    }
  }

  ngOnDestroy(): void {}

  private revokeBlobUrls(): void {
    if (CollectionHelper.isPopulated(this.blobUrls)) {
      this.blobUrls.forEach((url) => URL.revokeObjectURL(url));
      this.blobUrls.length = 0;
    }
  }

  onAssetsAdded(addedAssets: Asset[]): void {
    this.assets.push(...addedAssets);
    this.assetsAdded.next(addedAssets);
  }

  removeAsset(index: number): void {
    this.modalService.confirmDialog(
      'Foto verwijderen',
      'Bent u zeker dat u deze foto wilt verwijderen?',
      (b: boolean) => {
        if (b) {
          this.doRemoveAsset(index);
        }
      }
    );
  }

  private doRemoveAsset(index: number): void {
    const removedAssetSingleton = this.assets.splice(index, 1);
    if (CollectionHelper.isPopulated(removedAssetSingleton)) {
      if (removedAssetSingleton[0].localFileUuid != null) {
        this.ngForage.removeItem(
          AssetHelper.getStorageKeyFor(removedAssetSingleton[0].localFileUuid)
        );
      }
      this.assetDeleted.emit(removedAssetSingleton[0]);
    }
  }

  openLightbox(index: number): void {
    if (!CollectionHelper.isPopulated(this.assets)) {
      return;
    }
    const album = this.assets.map((a) => {
      const src =
        a.localSafeUrl != null
          ? <string>a.localSafeUrl
          : `/api/assets/${a.uuid}`;
      return {
        src: src,
        thumb: src,
      };
    });
    this._lightbox.open(album, index);
  }
}
